import { commerceFetch } from "./commerce-api";
import { getServerApiBase } from "../server-api-base";

interface ChangePasswordParams {
  old_password: string;
  new_password: string;
}

export async function changePassword({ old_password, new_password }: ChangePasswordParams) {
  const response = await commerceFetch(`/user/change_password/`, {
    method: "POST",
    body: JSON.stringify({
      old_password,
      new_password,
    }),
  });
  return response;
}

interface ChangePhoneParams {
  phone: string;
}

export async function changePhone({ phone }: ChangePhoneParams) {
  const response = await commerceFetch(`/user/change_phone/`, {
    method: "POST",
    body: JSON.stringify({
      phone,
    }),
  });
  return response;
}

interface ForgotPasswordParams {
  email: string;
}

export async function forgotPassword({ email }: ForgotPasswordParams) {
  const apiBase = getServerApiBase();
  const response = await fetch(`${apiBase}/user/forgot_password/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      email,
    }),
  });

  if (response.status === 404) {
    throw new Error("Kullanıcı bulunamadı");
  }

  if (response.status === 400) {
    throw new Error("Geçersiz email adresi");
  }

  return response;
}

interface ResetPasswordParams {
  token: string;
  new_password: string;
}

export async function resetPassword({ token, new_password }: ResetPasswordParams) {
  const response = await commerceFetch(`/user/reset_password/`, {
    method: "POST",
    body: JSON.stringify({
      token,
      new_password,
    }),
  });
  return response;
}

export interface CurrentUser {
  id: number;
  username: string;
  email: string;
  full_name: string;
  phone: string;
  company: string;
  address: string;
  city: string;
  district: string;
  /** API string (örn. "1250.50") */
  wallet_balance?: string;
  paytr_payment_required?: boolean;
}

export async function getCurrentUser(): Promise<CurrentUser> {
  const response = await commerceFetch(`/user/me/`, {
    method: "GET",
  });
  return response;
} 